import { render, staticRenderFns } from "./screen_admin_bodega.vue?vue&type=template&id=405d7666&scoped=true"
import script from "./screen_admin_bodega.vue?vue&type=script&lang=js"
export * from "./screen_admin_bodega.vue?vue&type=script&lang=js"
import style0 from "./screen_admin_bodega.vue?vue&type=style&index=0&id=405d7666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405d7666",
  null
  
)

export default component.exports